"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createEntityWrapper_1 = require("./createEntityWrapper");
var getEntityElement_1 = require("./getEntityElement");
var getEntityFromElement_1 = require("./getEntityFromElement");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Insert an entity into editor.
 * @param editor The editor to insert entity into.
 * @param type Type of the entity
 * @param contentNode Root element of the entity
 * @param isBlock Whether the entity will be shown as a block
 * @param isReadonly Whether the entity will be a readonly entity
 * @param position (Optional) The position to insert into. If not specified, current position will be used.
 * If isBlock is true, entity will be insert below this position
 */
function insertEntity(editor, type, contentNode, isBlock, isReadonly, position) {
    var wrapper = createEntityWrapper_1.default(editor, type, contentNode, isBlock, isReadonly);
    var currentRange;
    if (position) {
        currentRange = editor.getSelectionRange();
        var node = position.normalize().node;
        var existingEntity = getEntityElement_1.default(editor, node);
        // Do not insert entity into another entity
        if (existingEntity) {
            position = new roosterjs_editor_dom_1.Position(existingEntity, -3 /* After */);
        }
        editor.select(position);
    }
    editor.insertNode(wrapper, {
        updateCursor: false,
        insertOnNewLine: isBlock,
        replaceSelection: true,
        position: 3 /* SelectionStart */,
    });
    if (isBlock) {
        // Insert an extra empty line for block entity to make sure
        // user can still put cursor below the entity.
        var br = editor.getDocument().createElement('BR');
        wrapper.parentNode.insertBefore(br, wrapper.nextSibling);
    }
    if (currentRange) {
        editor.select(currentRange);
    }
    else if (!isBlock) {
        editor.select(wrapper, -3 /* After */);
    }
    var entity = getEntityFromElement_1.default(wrapper);
    editor.triggerContentChangedEvent("InsertEntity" /* InsertEntity */, entity);
    return entity;
}
exports.default = insertEntity;
//# sourceMappingURL=insertEntity.js.map